
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"19.5","fill":"#fff","stroke":"#DADFEB"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.906 11.38l-1.078 1.077L19.371 20l-7.543 7.543 1.078 1.077 7.542-7.543 7.543 7.543 1.077-1.078L21.526 20l7.542-7.543-1.077-1.077-7.543 7.542-7.542-7.542z","fill":"#000"}})])
          )
        }
      }
    